import { FormattedMessage, useIntl } from "react-intl";

import { Button, Checkbox } from "antd";

import { CmtFilterBar } from "@app/components/filters/CmtFilterBar.tsx";
import { CmtSearchFilter } from "@app/components/filters/CmtSearchFilter.tsx";

interface MissionPageFiltersProps {
  showingEndedMissions: boolean;
  clientSearch: string | undefined;
  userEmailSearch: string | undefined;
  handleClientSearchChange: (value: string) => void;
  handleUserEmailSearchChange: (value: string) => void;
  handleShowingEndedMissions: (value: boolean) => void;
  reset: () => void;
}

export function MissionPageFilters({
  showingEndedMissions,
  clientSearch,
  userEmailSearch,
  handleClientSearchChange,
  handleUserEmailSearchChange,
  handleShowingEndedMissions,
  reset,
}: Readonly<MissionPageFiltersProps>) {
  const intl = useIntl();
  const showResetButton =
    showingEndedMissions || !!clientSearch || !!userEmailSearch;

  return (
    <CmtFilterBar>
      <CmtSearchFilter
        defaultValue={clientSearch}
        placeholder={intl.formatMessage({
          id: "table.search_client_name",
          defaultMessage: "Search by client name",
        })}
        onQueryChange={handleClientSearchChange}
      />
      <CmtSearchFilter
        defaultValue={userEmailSearch}
        placeholder={intl.formatMessage({
          id: "table.search_takima_user",
          defaultMessage: "Search by employee name or email",
        })}
        onQueryChange={handleUserEmailSearchChange}
      />
      <Checkbox
        checked={showingEndedMissions}
        onChange={(event) => handleShowingEndedMissions(event.target.checked)}
      >
        <FormattedMessage
          id="table.showing_ended_mission_filter"
          defaultMessage="Finished missions only"
        />
      </Checkbox>
      {showResetButton && (
        <Button type="link" onClick={reset}>
          <FormattedMessage
            id="table.reset_filters"
            defaultMessage="Reset filters"
          />
        </Button>
      )}
    </CmtFilterBar>
  );
}
